import api from '@/api'

export default {
  namespaced: true,
  state: {
    communications: {},
    prevCommunications: {},
    isLoading: false
  },
  mutations: {
    SET_COMMUNICATIONS (state, info) {
      state.communications = JSON.parse(JSON.stringify(info))
      state.prevCommunications = JSON.parse(JSON.stringify(info))
    },
    UPDATE_COMMUNICATION_AVAILABILITY (state, { target, idx, data }) {
      state.communications[target][idx].is_active = data
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_COMMUNICATIONS (state) {
      state.communications = {}
      state.prevCommunications = {}
    }
  },
  actions: {
    async GET_COMMUNICATIONS ({ commit, state }) {
      try {
        commit('SET_IS_LOADING', true)

        const res = await api.cabinet.getCommunications()

        if (res.success) {
          commit('SET_COMMUNICATIONS', res.data)
        } else {
          commit('SET_COMMUNICATIONS', state.prevCommunications)
          throw new Error()
        }
      } catch (err) {
        commit('SET_COMMUNICATIONS', state.prevCommunications)
        throw err
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async SET_COMMUNICATIONS ({ commit, state }, { target, idx, data }) {
      try {
        commit('SET_IS_LOADING', true)
        commit('UPDATE_COMMUNICATION_AVAILABILITY', { target, idx, data })

        const res = await api.cabinet.setCommunications(state.communications)

        if (res.success) {
          commit('SET_COMMUNICATIONS', { ...res.data })
        } else {
          commit('SET_COMMUNICATIONS', state.prevCommunications)
          throw new Error()
        }
      } catch (err) {
        commit('SET_COMMUNICATIONS', state.prevCommunications)
        throw err
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    RESET_COMMUNICATIONS_ACTION ({ commit }) {
      commit('RESET_COMMUNICATIONS')
    }
  }
}
